<template>
  <b-sidebar
    @change="visibleChanged"
    v-model="showSidebar"
    shadow
    right
    backdrop
    :width="swd"
    no-header
    :style="`${zindex!='' ?'z-index:'+zindex+' !important':''}`"
  >
    <div class="content-header bd-b pd-0" v-if="ready">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px">
        <div class="dropdown">
          <a
            href="javascript:void(0)"
            data-toggle="dropdown"
            class="order-1 navbar-brand tx-bold tx-spacing--2"
            style="max-width: 500px; overflow: hidden; text-overflow: ellipsis"
          >
            <a
              class="text-white rounded-sm btn- btn-info btn-uppercase pd-x-15 pd-t-10 pd-b-8 mg-r-10"
            >
              <feather type="menu"></feather>цэс
            </a>
            {{ fileInf.title }}
            <feather type="chevron-down"></feather>
          </a>
          <div class="dropdown-menu tx-13">
            <!--  -->

            <a
              v-if="
                hasOneOf(['doceditor'], $store.state.user.access) &&
                fileInf.canEdit &&
                docExt == 'document'
              "
              role="button"
              @click="editDoc()"
              class="dropdown-item"
              >Засах</a
            >
            <a
              v-if="
                hasOneOf(['doceditor'], $store.state.user.access) &&
                fileInf.canEdit &&
                docExt == 'document'
              "
              role="button"
              @click="makeTemplate()"
              class="dropdown-item"
              >Загвар болгох</a
            >
            <a
              v-if="hasOneOf(['messenger'], $store.state.user.access)"
              @click="shareToMessenger()"
              class="dropdown-item"
              role="button"
              >Мессенжерт хавсралт болгож илгээх</a
            >
            <a role="button" @click="downloadFile()" class="dropdown-item"
              >Хавсралт файлыг татах</a
            >

            <a role="button" @click="changeFilePublic()" class="dropdown-item"
              >Төлөв солих ({{ fileInf.isPublic ? "нээлттэй" : "цоожтой" }})</a
            >
            <li>
              <hr class="dropdown-divider" />
            </li>
            <a role="button" @click="showMention()" class="dropdown-item">Хуваалцах</a>
            <a role="button" @click="showPermission()" class="dropdown-item">Тохиргоо</a>
          </div>
        </div>
        <button
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          class="order-2 navbar-toggler"
        >
          <feather type="menu"></feather>
        </button>
        <div
          id="navbarSupportedContent"
          class="order-2 collapse navbar-collapse"
        >
          <div fixed grow dense class="pa-0 ma-0 mg-l-50"></div>
          <button
            class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
            @click="visibleChanged(false)"
          >
            <feather class="mg-r-5" type="x"></feather>Хаах
          </button>
        </div>
      </nav>
    </div>

    <div class="bg-white" style="height: calc(100vh - 115px);">
      <loader
        :key="loaderKey"
        v-if="docExt != ''"
        :otCompName="docExt"
        :propFileId="id"
        :prms="prms"
      />
    </div>
    <div
      class="bg-gray-200 d-flex align-items-center bd-t pd-x-20 ht-55"
      v-if="ready"
    >
      <div class="d-flex justify-content-between wd-100p">
        <!-- <div>
          <button @click="downloadFile()" type="button" class="btn btn-xs btn-outline-primary d-flex align-items-center" >
            <feather type="download" size="16" class="mg-r-5"></feather>
            <span>Татах</span>
          </button>
        </div> -->
        <div class="d-flex align-items-center">
          №: {{ fileInf.id }}
          <button
            v-if="fileInf.isPublic"
            @click="downloadFile()"
            class="btn btn-xs btn-outline-success mg-l-10"
          >
            <feather type="download" class="mg-r-5"></feather>татах
          </button>
        </div>
        <div
          class="d-flex align-items-center"
          v-if="fileInf.user != undefined || fileInf.user != null"
        >
          <img
            :src="fileInf.user.avator"
            alt
            class="wd-30 rounded-circle mg-r-15"
          />
          <div>
            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
              {{ fileInf.user.fullName }}
            </h6>
            <span class="d-block tx-11 text-muted"></span>
          </div>
        </div>
        <!---->
        <div class="d-flex align-items-center">
          <div class="text-muted mg-r-10">Бүртгэсэн:</div>
          <div class="text-right">
            <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
              {{ fileInf.date | moment("dddd, HH:mm") }}
            </h6>
            <span class="d-block tx-11 text-muted">{{
              fileInf.date | moment("YYYY.MM.DD")
            }}</span>
          </div>
        </div>
      </div>
      <share-to-messenger
        @on-hide="shareToMessengerModal.show = false"
        :isShow.sync="shareToMessengerModal.show"
        :prms.sync="shareToMessengerModal.prms"
        :key="shareToMessengerModal.key"
      ></share-to-messenger>
      <!-- <Modal
      :transition-names="[]"
      title="Загварын нэр оруулна уу"
      v-model="modalTemplate"
      @on-cancel="modalTemplate=false"
      :mask-closable="false"
    > -->
      <b-modal
        v-model="modalTemplate"
        title="Загварын нэр оруулна уу"
        scrollable
        no-fade
        centered
        size="xs"
        @hide="modalTemplate = false"
        ><div class="modal-body">
          <div class="form-group">
            <label for="modalTemplateTitle" class="d-block">Загварын нэр</label>
          <input
            class="form-control"
            v-model="modalTemplateTitle"
            placeholder="Загварын нэр..."
          />
          </div>
        </div>
        <!-- <div slot="footer">
        
      </div> -->
        <template #modal-footer>
          <div style="color: #999; float: left" class="p-t-xs">
            Файл : {{ modalTemplateTitleTemp }}
          </div>
          <div class="btn-group" role="group" aria-label="үйлдэл">
            <button
              type="button"
              @click="modalTemplate = false"
              class="btn btn-light"
            >
              Болих
            </button>
            <button
              type="button"
              @click="savedoctheme()"
              class="btn btn-success"
            >
              Хадгалах
            </button>
          </div>
        </template>
      </b-modal>
      <!-- </Modal> -->
    </div>

    

    <file-users
      ref="fleUsrs"
      :show="projectEdit.show"
      :obj.sync="fileInf"
      module="file"
      @on-edit-close="projectEdit.show = false"
      @on-share="showMention"
    ></file-users>

    <mention-users
      :show="projectMention.show"
      :obj.sync="fileInf"
      :module="projectMention.module"
      @on-force="fileUsersLdeHhh"
      @on-mention-close="projectMention.show = false"
    ></mention-users>

  </b-sidebar>
</template>

<script>
import { mapActions } from "vuex";
import { getFileMode, hasOneOf } from "@/libs/tools";
import { filePreData, filePreviewDetail } from "@/api/media";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
  name: "FileDetail",
  components: {
    loader: () => ({
      component: import("@/components/modules/media/components/loader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    shareToMessenger: () => ({
      component: import("@/components/modules/messenger/shareToMessenger"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileUsers: () => ({
      component: import("@/components/project/users.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    swd: {
      type: String,
      default: () => "90vw",
    },
    id: {
      type: Number,
      default: () => 0,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    zindex:{
      type: Number,
      default: () => 0,
    }
  },
  data() {
    return {
      docExt: "",
      fileInf: {},
      prms: {},
      loaderKey: 0,
      showSidebar: false,
      ready: false,
      shareToMessengerModal: {
        show: false,
        prms: {
          objectId: 0,
          objectTypeId: 0,
        },
        key: 1500,
      },
      modalTemplateTitle: "",
      modalTemplate: false,
      modalTemplateTitleTemp: "",
      modalTemplateID: 0,

      projectMention: {
        module: "file",
        show: false,
      },
      projectEdit: {
        id: 0,
        redner: false,
        show: false,
        mode: 0,
      },
    };
  },
  mounted() {
    if (this.id > 0) this.fileDetail();
  },
  methods: {
    ...mapActions(["handleLoading"]),
    hasOneOf(tarr, arr) {
      return hasOneOf(tarr, arr);
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    makeTemplate() {
      this.modalTemplateID = this.id;
      this.modalTemplateTitleTemp = this.fileInf.title;
      this.modalTemplate = true;
    },
    savedoctheme() {
      if (this.modalTemplateTitle.length > 0) {
        request({
          api: { method: "POST", url: "Media/SaveTemplate" },
          data: {
            fileId: this.modalTemplateID,
            title: this.modalTemplateTitle,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.$bvToast.toast("Амжилттай", {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
            });
            this.modalTemplate = false;
          }
        });
      } else {
        this.$bvToast.toast("Загварын нэр оруулна уу", {
          title: "Мэдэгдэл",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "warning",
        });
      }
    },
    editDoc() {
      let _h = screen.availHeight - 60;
      let _w = screen.availWidth - 20;
      window.open(
        "#/Media/EditorBlank/" + this.id,
        "_blank",
        "toolbar=no,scrollbars=yes,resizable=yes,top=0,left=0,width=" +
          _w +
          ",height=" +
          _h
      );

      this.visibleChanged(false);
    },
    shareToMessenger() {
      this.shareToMessengerModal.prms.objectId = this.id;
      this.shareToMessengerModal.prms.objectTypeId = 6;
      this.shareToMessengerModal.show = true;
      this.shareToMessengerModal.key++;
    },
    fileDetail() {
      
      this.showSidebar = true;
      filePreData({ params: { id: this.id }, store: this.$store }).then(
        (res) => {
          if (res != false) {
            this.docExt = getFileMode(res.data.file.extension);
            // console.log('file detail fired', this.docExt)
            this.loaderKey++;
            filePreviewDetail({
              params: { id: this.id },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                //console.log(res);

                this.fileInf = res.data.file;
                this.ready = true;
              }
            });
          } else {
            this.visibleChanged(false);
          }
        }
      );
    },
    changeFilePublic() {
      request({
        api: { method: "POST", url: "Media/FileSetIsPublic" },
        data: {
          id: this.id,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.fileDetail();
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true,
            variant: "success",
            toaster: "b-toaster-bottom-left",
          });
        }
      });
    },
    downloadFile() {
      if (this.$store.state.user.userInfo.groupId == 9235  || this.$store.state.user.userInfo.groupId == 9362 || this.$store.state.user.userInfo.groupId == 9351  || this.$store.state.user.userInfo.groupId == 9363 || this.$store.state.user.userInfo.groupId == 9290) {
        if (!this.hasPermission(["learningoffice"])) {
          window.open(
            this.fileInf.link + "?i=" + Math.floor(Math.random() * 100),
            "_blank"
          );
        } else {
          //this.$Message.warning({ content: "Файлыг татах боломжгүй" });
          this.$bvToast.toast("Файлыг татах боломжгүй", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true,
            variant: "warning",
            toaster: "b-toaster-bottom-left",
          });
        }
      } else if (
        !this.hasPermission(["learningadmin", "learningteacher"]) &&
        this.hasPermission(["learningstudent"])
      ) {
        this.$bvToast.toast("Файлыг татах боломжгүй", {
          title: "Мэдэгдэл",
          autoHideDelay: 500,
          appendToast: true,
          variant: "warning",
          toaster: "b-toaster-bottom-left",
        });
      } else {
        window.open(
          this.fileInf.link + "?i=" + Math.floor(Math.random() * 100),
          "_blank"
        );
      }
    },
    visibleChanged(e) {
      if (!e) {
        //console.log('step 856')
        this.projectMention.show = false;
        this.projectEdit.show= false;

        this.showSidebar = false;
        this.$emit("on-hide");
      }
    },

    showPermission(){
      this.projectEdit.show= true;
    },
    showMention(){
      this.projectMention.show = true;
    },
    fileUsersLdeHhh(){
      //console.log('this.$refs[0]', this.$refs);
      this.$refs.fleUsrs.init();
    },
  },
  computed: {
    courseid() {
      return this.show;
    },
  },
  watch: {
    courseid(val) {
      if (val) {
        this.fileDetail();
      }
    },
  },
};
</script>
